// import React, { useState } from 'react';
// import { Grid, Tabs, Tab, Box, TextField, Button, Paper, Typography, Container } from '@mui/material';
// import { makeStyles } from '@mui/styles';
// import LoginForm from './LoginForm';
// import SignupForm from './SignUpForm';
// const useStyles = makeStyles((theme) => ({
//     formContainer: {
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//     },
//     tabContent: {
//         padding: theme.spacing(2),
//     },
//     leftSide: {
//         backgroundColor: theme.palette.primary.main,
//         color: theme.palette.primary.contrastText,
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//     },
//     rightSide: {
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//     },
// }));

// function LoginSignUp() {
//     const classes = useStyles();
//     const [activeTab, setActiveTab] = useState(0);

//     const handleChange = (event, newValue) => {
//         setActiveTab(newValue);
//     };

//     return (
//         <Grid container style={{ height: '100vh', display: "flex", alignItems: "center", justifyContent: "center" }}>
//             {/* <Grid item xs={12} md={7} className={classes.leftSide}>
//                 <Typography variant="h1">Welcome</Typography>
//             </Grid> */}
//             <Grid item xs={12} md={5} className={classes.rightSide}>
//                 <Container sx={{ height: "100vh" }} className={classes.formContainer}>
//                     <Paper sx={{ height: "90%" }}>
//                         <Tabs value={activeTab} onChange={handleChange} centered>
//                             <Tab label="Login" />
//                             <Tab label="Sign Up" />
//                         </Tabs>
//                         <Box className={classes.tabContent}>
//                             {activeTab === 0 && (
//                                 <form>
//                                     <LoginForm />
//                                 </form>
//                             )}
//                             {activeTab === 1 && (
//                                 <form>
//                                     <SignupForm />
//                                 </form>
//                             )}
//                         </Box>
//                     </Paper>
//                 </Container>
//             </Grid>
//         </Grid>
//     );
// }

// export default LoginSignUp;


import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignUpForm';
import { Box, Button } from '@mui/material';
import './login.css'
const LoginSignUp = () => {
    const [isRightPanelActive, setIsRightPanelActive] = useState(false);

    const handleSignUpClick = () => {
        setIsRightPanelActive(true);
    };

    const handleSignInClick = () => {
        setIsRightPanelActive(false);
    };

    return (
        <Box className="LoginSign4334">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }} className={`container ${isRightPanelActive ? 'right-panel-active' : ''}`} id="container">
                <LoginForm />
                <SignupForm />
                <div className="overlay-container">
                    <div className="overlay">
                        <div className="overlay-panel overlay-left">
                            <h1>Welcome Back!</h1>
                            <p>To keep connected with us please login with your personal info</p>
                            <button className="ghost" id="signIn" onClick={handleSignInClick}>Sign In</button>
                        </div>
                        <div className="overlay-panel overlay-right">
                            <h1>Hello, Friend!</h1>
                            <p>Enter your personal details and start journey with us</p>
                            <button variant='contained' className="ghost" id="signUp" onClick={handleSignUpClick}>Sign Up</button>
                        </div>
                    </div>
                </div>
            </div>
        </Box>
    );
};

export default LoginSignUp;
